import { DelegationScope } from '@g17eco/types/surveyDelegation';
import { ViewValues } from '@g17eco/types/surveyOverview';

// Virtual types that will be converted to standard or framework
export const virtualTypes = [
  ViewValues.StandardsAndFrameworks,
  ViewValues.Regulatory,
  ViewValues.Ratings,
  ViewValues.QuestionPacks,
  ViewValues.AllPacks,
  ViewValues.Archived,
] as const;

// All types that are handled by standard and frameworks
export const standardsAndFrameworkTypes = [
  ...virtualTypes,
  ViewValues.Standards,
  ViewValues.Frameworks,
] as const;

export type VirtualScopeType = typeof virtualTypes[number];
export type StandardsFrameworksTypes = typeof standardsAndFrameworkTypes[number];

export type DelegationScopeOptions = keyof DelegationScope | VirtualScopeType;
